import { footerStyles } from "@insite/content-library/Pages/Footer";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

footerStyles.page = {
    fullWidth: [true, true, true, true, true],
        css: css`
        background-color: #252129;
        > div[class^="Wrapper"]{
            .FooterContainerLinkList{
                padding: 20px;
                .list-wrapper{
                    display: flex;
                    justify-content: center;
                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                flex-direction: column;
                            `,
                            css`
                                flex-direction: column;
                            `,
                            css`
                                white-space: nowrap;
                            `,
                            css`
                                white-space: nowrap;
                            `,
                        ],
                        "max",
                    )}
                    .title-wrapper{
                        margin-right: 5px;
                        span{
                            color: ${getColor("text.main")};
                            text-transform: none;
                            font-size: 18px;
                            font-weight: 800;
                        }
                    }
                    .links-wrapper{
                        padding: 1px 5px 0 0;
                        span{
                            color: ${getColor("text.main")};
                            text-transform: none;
                            font-size: 18px;
                            font-weight: 500;
                        }
                    }
                }
            }
        }
        `,
};
